import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import { Texture } from "three";
import useStore from "./useStore";
import { useShallow } from "zustand/react/shallow";

const HEAVY_TEXTURES_PREFIXES = ["fuse_signal_"];

const PreloadTexturesOnScene = () => {
  const { scene, gl, camera } = useThree();

  const [texturesCache, setTexturesPreloadedOnScene, texturesPreloadedOnScene] =
    useStore(
      useShallow((state: any) => [
        state.texturesCache,
        state.setTexturesPreloadedOnScene,
        state.texturesPreloadedOnScene,
      ]),
    );

  useEffect(() => {
    if (gl && texturesCache.length > 0) {
      Promise.all(
        texturesCache
        /*   .filter((texture: Texture) =>
            HEAVY_TEXTURES_PREFIXES.find((texture_prefix: string) =>
              texture.userData.name.includes(texture_prefix),
            ),
          ) */
          .map((texture: Texture) => {
            return new Promise<void>((resolve) => {
              gl.initTexture(texture);
              resolve();
            });
          }),
      ).then(() => {
        setTexturesPreloadedOnScene(true);
      });
    }
  }, [texturesCache, gl]);

  return <></>;
};

export default PreloadTexturesOnScene;
